'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';
import styles from './InstagramFeed.module.css';
import { trackEvent } from '@/lib/analytics/firebaseAnalytics';
import { AnalyticsEvents } from '@/lib/analytics/events';

// Extend Window interface for Instagram embed
declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
  }
}

const InstagramFeed = () => {
  const [hasTrackedView, setHasTrackedView] = useState(false);

  useEffect(() => {
    // Process Instagram embeds after script loads
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }

    // Track Instagram feed section view
    if (!hasTrackedView) {
      trackEvent(AnalyticsEvents.VIEW_INSTAGRAM_FEED);
      setHasTrackedView(true);
    }
  }, [hasTrackedView]);

  return (
    <>
      <Script
        src="https://www.instagram.com/embed.js"
        strategy="lazyOnload"
        onLoad={() => {
          if (window.instgrm) {
            window.instgrm.Embeds.process();
          }
        }}
      />
      
      <section className={styles.instagramSection} id="instagram">
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.title}>Follow My Journey</h2>
            <p className={styles.subtitle}>
              Get daily fitness inspiration, workout tips, and behind-the-scenes content on Instagram
            </p>
          </div>
          
          <div className={styles.feedContainer}>
            {/* Instagram Embed */}
            <div className={styles.embedWrapper}>
              <blockquote 
                className="instagram-media" 
                data-instgrm-permalink="https://www.instagram.com/lior_murphy/"
                data-instgrm-version="14"
                style={{
                  background: '#FFF',
                  border: 0,
                  borderRadius: '3px',
                  boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                  margin: '1px',
                  maxWidth: '540px',
                  minWidth: '326px',
                  padding: 0,
                  width: 'calc(100% - 2px)',
                }}
              >
              </blockquote>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default InstagramFeed;

